var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _rect8, _rect9, _rect10, _rect11, _rect12, _text, _text2, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _ellipse, _path2, _circle8, _circle9, _path3, _rect13, _polygon, _rect14, _circle10, _rect15, _g, _line, _line2, _line3, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaundryPickup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 150,
    r: 130,
    fill: "#EBF8FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 220,
    width: 320,
    height: 8,
    rx: 4,
    fill: "#E2E8F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 222,
    width: 20,
    height: 4,
    rx: 2,
    fill: "#CBD5E0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 222,
    width: 20,
    height: 4,
    rx: 2,
    fill: "#CBD5E0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 222,
    width: 20,
    height: 4,
    rx: 2,
    fill: "#CBD5E0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 222,
    width: 20,
    height: 4,
    rx: 2,
    fill: "#CBD5E0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 155,
    width: 160,
    height: 65,
    rx: 8,
    fill: "#4299E1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 155,
    width: 160,
    height: 20,
    rx: 8,
    fill: "#3182CE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260 170 L290 170 C295 170 300 175 300 180 L300 220 L260 220 L260 170Z",
    fill: "#2B6CB0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 178,
    width: 28,
    height: 22,
    rx: 4,
    fill: "#BEE3F8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 175,
    width: 50,
    height: 45,
    rx: 3,
    fill: "#2B6CB0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 180,
    width: 18,
    height: 35,
    rx: 2,
    fill: "#BEE3F8",
    opacity: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 180,
    width: 18,
    height: 35,
    rx: 2,
    fill: "#BEE3F8",
    opacity: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 182,
    width: 90,
    height: 28,
    rx: 4,
    fill: "white",
    opacity: 0.9
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 205,
    y: 200,
    fontFamily: "Arial, sans-serif",
    fontSize: 10,
    fontWeight: "bold",
    fill: "#2B6CB0",
    textAnchor: "middle"
  }, "FREE PICKUP")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 205,
    y: 212,
    fontFamily: "Arial, sans-serif",
    fontSize: 8,
    fill: "#4299E1",
    textAnchor: "middle"
  }, "&amp; DELIVERY")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 222,
    r: 14,
    fill: "#2D3748"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 222,
    r: 7,
    fill: "#718096"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 222,
    r: 3,
    fill: "#2D3748"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 222,
    r: 14,
    fill: "#2D3748"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 222,
    r: 7,
    fill: "#718096"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 222,
    r: 3,
    fill: "#2D3748"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 180,
    cy: 148,
    rx: 22,
    ry: 18,
    fill: "#63B3ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165 135 C165 128 175 122 180 122 C185 122 195 128 195 135",
    stroke: "#2B6CB0",
    strokeWidth: 2.5,
    fill: "none",
    strokeLinecap: "round"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 145,
    r: 3,
    fill: "white",
    opacity: 0.6
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 150,
    r: 2,
    fill: "white",
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175 143 L178 140 L180 141 L182 140 L185 143 L183 144 L183 151 L177 151 L177 144 Z",
    fill: "white",
    opacity: 0.8
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 100,
    width: 50,
    height: 50,
    rx: 3,
    fill: "#F7FAFC",
    stroke: "#E2E8F0",
    strokeWidth: 1.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "30,100 55,78 80,100",
    fill: "#4299E1"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 120,
    width: 16,
    height: 30,
    rx: 2,
    fill: "#90CDF4"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 136,
    r: 1.5,
    fill: "#2B6CB0"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 110,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#BEE3F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 0 C-2 0 -7 5 -7 11 C-7 19 5 28 5 28 C5 28 17 19 17 11 C17 5 12 0 5 0Z",
    fill: "#E53E3E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 11,
    r: 4,
    fill: "white"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 85,
    y1: 185,
    x2: 70,
    y2: 185,
    stroke: "#90CDF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 85,
    y1: 195,
    x2: 65,
    y2: 195,
    stroke: "#90CDF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 85,
    y1: 205,
    x2: 72,
    y2: 205,
    stroke: "#90CDF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#4299E1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320 90 L322 95 L327 97 L322 99 L320 104 L318 99 L313 97 L318 95Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 120 L341 123 L344 124 L341 125 L340 128 L339 125 L336 124 L339 123Z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 70 L91 73 L94 74 L91 75 L90 78 L89 75 L86 74 L89 73Z",
    opacity: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaundryPickup);
export default __webpack_public_path__ + "static/media/laundry-pickup.275aa24dc92f9d36c393c30c01f6325f.svg";
export { ForwardRef as ReactComponent };